import { useMemo } from 'react';

import { useQuery } from '@tanstack/react-query';

import { getTendersWithInteraction } from '../../../../../../../../../shared/api/magellan/interaction';
import type { DecisionStatus } from '../../../../../../../../../shared/entities/Interaction';
import { TenderStatus } from '../../../../../../../../../shared/entities/Tender';

interface UseTendersWithInteractionQueryProps {
  search?: string;
  decisionStatus?: DecisionStatus;
  status?: TenderStatus[];
}

const RESULTS_PER_PAGE = 50;

export function useTendersWithInteractionQuery({
  search,
  decisionStatus = undefined,
  status = [TenderStatus.OPEN],
}: UseTendersWithInteractionQueryProps) {
  const params = useMemo(() => {
    return {
      ...(search && { q: search }),
      ...(decisionStatus && { decisionStatus }),
      ...(status && { tenderStatus: status?.join(',') as TenderStatus }),
      take: RESULTS_PER_PAGE,
    };
  }, [search, decisionStatus, status]);

  function queryFn() {
    return getTendersWithInteraction({ ...params });
  }

  return useQuery({
    queryKey: [getTendersWithInteraction.name, params],
    queryFn,
  });
}
